import { TZB_URL } from "appLauncher";
import { useEffect, useState } from "react";
import styled from "styled-components";

const BannerSection = styled.section<{ $visible: boolean }>`
  background-image: url(/assets/home/banner.png);
  background-position: center;
  background-color: #2640ed;
  color: #fff;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px 0;
  height: 433px;
  user-select: none;

  animation: ${(props) => (props.$visible ? "fadeIn 2s" : "fadeOut 1s")};
  opacity: ${(props) => (props.$visible ? "1" : "0")};
  position: ${(props) => (props.$visible ? "relative" : "absolute")};
  left: 0;
  top: 0;
  width: 100%;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0.8;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`;

const BannerContent = styled.div`
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  box-sizing: border-box;
  padding: 0 32px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 24px;
  }
`;

const BannerTitle = styled.h1`
  font-size: 45px;
  margin-bottom: 10px;
  text-align: left;
  width: 100%;
  min-width: 158px;
  > span {
    white-space: nowrap;
  }
  @media (max-width: 900px) {
    text-align: center;
    width: auto;
  }
`;

const BannerLeft = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media (max-width: 900px) {
    align-items: center;
  }
`;

const BannerText = styled.p`
  margin-bottom: 20px;
  text-align: left;
  width: 100%;
  min-width: 158px;
  font-size: 18px;
  letter-spacing: 6px;
  @media (max-width: 900px) {
    text-align: center;
    width: auto;
  }
`;

const ApplyButton = styled.a`
  background-color: #fff;
  color: #004ac8;
  width: 158px;
  height: 49px;
  line-height: 49px;
  text-align: center;
  padding: 0;
  border-radius: 5px;
  text-decoration: none;
  display: inline-block;
  font-size: 18px;
  font-weight: 500;
  transition: background-color 0.3s, color 0.3s;
  margin-left: 0;
  margin-top: 0;
  cursor: pointer;
  &:hover {
    background-color: #e8d3d3ff;
  }
  @media (max-width: 900px) {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
`;
const ButtonPrimary = styled(ApplyButton)`
  background-color: #2640ed;
  color: #fff;
  &:hover {
    background-color: #2640ed6d;
  }
`;
function Banner1({ visible }: { visible: boolean }) {
  return (
    <BannerSection
      $visible={visible}
      style={{ backgroundImage: "url(" + "/assets/home/banner1.png" + ")" }}
    >
      <BannerContent>
        <BannerLeft>
          <BannerTitle>
            <span>全程线上办理</span>
            <span
              style={{
                display: "inline-block",
                margin: "0 24px",
              }}
            ></span>
            <span>安全合规 零风险</span>
          </BannerTitle>
          <BannerText>
            区块链存证+电子签章，资金安全与数据隐私双重保障
          </BannerText>
          <ApplyButton onClick={() => window.open(TZB_URL, "_blank")}>
            立即申请
          </ApplyButton>
        </BannerLeft>
      </BannerContent>
    </BannerSection>
  );
}
function Banner2({ visible }: { visible: boolean }) {
  return (
    <BannerSection
      $visible={visible}
      style={{ backgroundImage: "url(" + "/assets/home/banner2.png" + ")" }}
    >
      <BannerContent>
        <BannerLeft>
          <BannerTitle>
            <span>成本直降60%</span>
            <span
              style={{
                display: "inline-block",
                margin: "0 24px",
              }}
            ></span>
            <span>保函管理更灵活</span>
          </BannerTitle>
          <BannerText>✓ 按需申请、动态调整，告别高额保证金占用</BannerText>
          <ApplyButton onClick={() => window.open(TZB_URL, "_blank")}>
            立即申请
          </ApplyButton>
        </BannerLeft>
      </BannerContent>
    </BannerSection>
  );
}
function Banner3({ visible }: { visible: boolean }) {
  return (
    <BannerSection
      $visible={visible}
      style={{ backgroundImage: "url(" + "/assets/home/banner3.png" + ")" }}
    >
      <BannerContent>
        <BannerLeft>
          <BannerTitle>
            <span>30秒极速出函</span>
            <span
              style={{
                display: "inline-block",
                margin: "0 24px",
              }}
            ></span>
            <span>业务快人一步</span>
          </BannerTitle>
          <BannerText>
            ✓ 7×24小时自助申请，全流程数字化，告别传统纸质繁琐 ✓
          </BannerText>
          <BannerText>支持投标/履约/预付款等多种保函类型</BannerText>
          <ButtonPrimary onClick={() => window.open(TZB_URL, "_blank")}>
            立即申请
          </ButtonPrimary>
        </BannerLeft>
      </BannerContent>
    </BannerSection>
  );
}

export default function Banner() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((i) => (i + 1) % 3);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  return (
    <div style={{ position: "relative" }}>
      <Banner1 visible={index === 0} />
      <Banner2 visible={index === 1} />
      <Banner3 visible={index === 2} />
    </div>
  );
}
